import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "card-like--sprite",
  "use": "card-like--sprite-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"card-like--sprite\">\n<path d=\"M6 10.5876L5.275 9.9276C2.7 7.5926 1 6.0526 1 4.1626C1 2.6226 2.21 1.4126 3.75 1.4126C4.62 1.4126 5.455 1.8176 6 2.4576C6.545 1.8176 7.38 1.4126 8.25 1.4126C9.79 1.4126 11 2.6226 11 4.1626C11 6.0526 9.3 7.5926 6.725 9.9326L6 10.5876Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol